import { ColumnDef, createColumnHelper } from "@tanstack/react-table";
import { Layout } from "../../components/Layout/Layout";
import { useEffect, useMemo, useState } from "react";
import { Flex, Text } from "@chakra-ui/react";
import { BaseTable } from "@/components/BaseTable/BaseTable";
import { useAppDispatch, useAppSelector } from "../../store";
import { fetchAllDepartments } from "../../store/slices/departments";
import { useNavigate } from "react-router-dom";
import { selectUserRole } from "@/store/slices/user";
import { UserRole } from "api/auth/types";
import { getChannels } from "api/channel";
import { RecruitmentChannel } from "@/model/recruitment";
import Select from "react-select";
import { Department } from "@/model/department";

const columnHelper = createColumnHelper<Department>();

type ChannelOption = { value: number; label: string };

const selectStyles = {
  control: (styles: any) => ({
    ...styles,
    width: "300px",
    maxWidth: "473px",
    borderColor: "#D6D6D6",
    zIndex: 1,
  }),
  menu: (styles: any) => ({
    ...styles,
    zIndex: 5000,
  }),
};

export const AllDivisionPage = () => {
  const role = useAppSelector(selectUserRole);

  const [channels, setChannels] = useState<RecruitmentChannel[]>([]);
  const [selectedChannel, setSelectedChannel] = useState<ChannelOption | null>(null);
  const channelOptions = useMemo<ChannelOption[]>(() => channels?.map((c) => ({ value: c.id, label: c.name })) ?? [], [channels]);

  const { departments, isLoading } = useAppSelector((state) => state.departments);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchAllDepartments(selectedChannel?.value));

    if (role === UserRole.ADMIN) {
      (async () => {
        try {
          const { data } = await getChannels({ main: false });
          console.log(data);

          setChannels(data);
        } catch (error) {
          console.error(error);
        }
      })();
    }
  }, [dispatch, role, selectedChannel?.value]);

  useEffect(() => {
    dispatch(fetchAllDepartments(selectedChannel?.value));
  }, [selectedChannel, dispatch]);

  const handleRowClick = (id: string) => {
    navigate(`${id}`);
  };

  const columns = useMemo<Array<ColumnDef<Department, any>>>(
    () => [
      columnHelper.accessor("name", {
        header: "Подразделение",
        cell: (info) => info.getValue(),
      }),
      columnHelper.accessor("recruitersCountActive", {
        header: "Количетсво рекрутеров",
        cell: (info) => info.getValue(),
      }),
      columnHelper.accessor("manager.fullName", {
        header: "Руководитель подразделения",
        cell: (info) => info.getValue(),
      }),
    ],
    [],
  );
  return (
    <Layout>
      <Flex flexDirection="column" maxH="90vh" overflowY="auto" gap="32px">
        <Text fontSize={27} fontWeight={500}>
          Подразделения
        </Text>
        {role === UserRole.ADMIN && (
          <Flex gap="16px">
            <Select
              menuPosition="absolute"
              className="basic-single"
              classNamePrefix="select"
              isSearchable={false}
              name="channels"
              styles={selectStyles}
              options={channelOptions}
              value={selectedChannel}
              placeholder="Выберите канал"
              isClearable
              onChange={(value) => setSelectedChannel(value as ChannelOption | null)}
            />
          </Flex>
        )}
        <BaseTable list={departments.items} columns={columns} isLoading={isLoading} />
      </Flex>
    </Layout>
  );
};
